import { makeWriteContractAsync } from '@/utils/wagmi/makeOperations'
import { usePepperContractAddress } from './usePepperContract'
import { abi } from '@/abi/Pepper'
import { wagmiConfig } from '@/config/wagmi-config'
import { useMemo } from 'react'

export function useWritePepperContract() {
	const pepperAddress = usePepperContractAddress()

	return useMemo(() => makeWriteContractAsync(wagmiConfig, { abi, address: pepperAddress }), [pepperAddress])
}
